import React from 'react'
import img1 from '../../imgs/saude-bucal/aparelhos/img-1.png'
import img2 from '../../imgs/saude-bucal/aparelhos/img-2.png'
import img3 from '../../imgs/saude-bucal/aparelhos/img-3.png'
import Carroussel from '../../components/Carroussel';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function Aparelhos() {
	const cardsData = [
		{
			id: 1,
			title: 'Aparelho ortodôntico fixo',
			image: img1,
		},
		{
			id: 2,
			title: 'Aparelho ortodôntico móvel',
			image: img2,
		},
		{
			id: 3,
			title: 'Alinhadores',
			image: img3,
		},
	];
	return (
		<div className='container' style={{ paddingTop: 60, paddingBottom: 120, background: 'linear-gradient(to bottom, #dceeff, #f3eaff)' }}>
			<h1 style={{ textAlign: 'center' }}>APARELHOS ORTODÔNTICOS</h1>
			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon />Os aparelhos ortodônticos são uma solução comum e eficaz para corrigir problemas de alinhamento e mordida nos dentes;</p>
			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon />Existem diversos aparelhos na odontologia  (fixo; móvel; alinhadores e outros);</p>
			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon />Melhoria significativa na saúde bucal;</p>
			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon />Proporciona benefícios funcionais e estéticos;</p>
			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon />Apenas os cirurgiões-dentistas são capacitados a indicarem a utilização dos aparelhos.</p>

			<p style={{ fontWeight: 'bold' }}><span style={{ color: 'red' }}>OBSERVAÇÃO:</span> No momento, o SUS não oferece aparelhos ortodônticos para adolescentes, pois esse tipo de tratamento não está incluído na cobertura. No entanto, converse com seu dentista! Ele pode esclarecer suas dúvidas e orientar sobre outras opções disponíveis. </p>

			<div>

				<Carroussel height={300} cardsData={cardsData} />
			</div>
		</div>
	)
};